import { installLegacyZodErrorMessages } from "@frontend-shared/schema/zod-error-messages";

// NOTE: NSAI-5511 — keeps zod's default messages worded as they were before the
// zod 4 upgrade, for every form field that has no message of its own. Loaded for
// its side effect from `main.tsx`, before the app's own modules.
installLegacyZodErrorMessages();
